"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.ReleaseVersion = exports.DebugContent = exports.ChinaICPLink = exports.ChinaFooterContainer = exports.PrivacyLink = exports.LegalLink = exports.Copyright = exports.Container = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = __importDefault(require("../../constants"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
function getColor(theme, color) {
    return color || (theme === 'light' ? "".concat(globalVars_module_scss_1.default.white) : "".concat(globalVars_module_scss_1.default.gray2));
}
function getBgColor(theme, bgColor) {
    return bgColor || (theme === 'light' ? "".concat(globalVars_module_scss_1.default.mainBlue) : "".concat(globalVars_module_scss_1.default.secondaryBlue));
}
exports.Container = styled_components_1.default.div.attrs({
    className: 'footer-container tws-footer-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\talign-items: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tdisplay: ", ";\n\tflex-direction: column;\n\tfont-size: ", ";\n\tfont-weight: ", ";\n\theight: 100px;\n\tjustify-content: ", ";\n\tline-height: 1;\n"], ["\n\talign-items: ", ";\n\tbackground-color: ", ";\n\tcolor: ", ";\n\tdisplay: ", ";\n\tflex-direction: column;\n\tfont-size: ", ";\n\tfont-weight: ", ";\n\theight: 100px;\n\tjustify-content: ", ";\n\tline-height: 1;\n"])), globalVars_module_scss_1.default.alignCenter, function (prop) { return getBgColor(prop.theme, prop.bgColor); }, function (prop) { return getColor(prop.theme, prop.color); }, globalVars_module_scss_1.default.displayFlex, function (props) { return props.fontSize; }, globalVars_module_scss_1.default.fontWeightNormal, globalVars_module_scss_1.default.alignCenter);
exports.Container.displayName = 'Container';
exports.Copyright = styled_components_1.default.span.attrs({
    className: 'copyright tws-footer-copyright',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.Copyright.displayName = 'Copyright';
exports.LegalLink = styled_components_1.default.a.attrs({
    className: 'legal-link tws-footer-legal-link',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"], ["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"])), function (prop) { return getColor(prop.theme, prop.color); }, globalVars_module_scss_1.default.spacing10, function (prop) { return getColor(prop.theme, prop.color); });
exports.LegalLink.displayName = 'LegalLink';
exports.PrivacyLink = styled_components_1.default.a.attrs({
    className: 'privacy-link tws-footer-privacy-link',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"], ["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"])), function (prop) { return getColor(prop.theme, prop.color); }, globalVars_module_scss_1.default.spacing10, function (prop) { return getColor(prop.theme, prop.color); });
exports.PrivacyLink.displayName = 'PrivacyLink';
exports.ChinaFooterContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t {\n\t\tpadding-top: 10px;\n\t}\n"], ["\n\t {\n\t\tpadding-top: 10px;\n\t}\n"])));
exports.ChinaFooterContainer.displayName = 'ChinaFooterContainer';
exports.ChinaICPLink = styled_components_1.default.a.attrs({
    className: 'china-icp-link tws-footer-china-icp-link',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"], ["\n\tcolor: ", ";\n\tmargin-left: ", ";\n\ttext-decoration: underline;\n\t:hover {\n\t\ttext-decoration: underline;\n\t\tcolor: ", ";\n\t}\n"])), function (prop) { return getColor(prop.theme, prop.color); }, globalVars_module_scss_1.default.spacing10, function (prop) { return getColor(prop.theme, prop.color); });
exports.ChinaICPLink.displayName = 'ChinaICPLink';
exports.DebugContent = styled_components_1.default.div.attrs({
    className: 'footer-debug-content tws-footer-debug-content',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\talign-items: ", ";\n\tdisplay: ", ";\n\tflex-direction: column;\n\tjustify-content: ", ";\n\tmargin-top: ", ";\n"], ["\n\talign-items: ", ";\n\tdisplay: ", ";\n\tflex-direction: column;\n\tjustify-content: ", ";\n\tmargin-top: ", ";\n"])), globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.displayFlex, globalVars_module_scss_1.default.alignCenter, globalVars_module_scss_1.default.spacing10);
exports.DebugContent.displayName = 'DebugContent';
exports.ReleaseVersion = styled_components_1.default.div.attrs({
    className: 'release-version tws-footer-release-version',
})(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
exports.ReleaseVersion.displayName = 'ReleaseVersion';
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var _a;
        var privacyURL;
        if (this.props.isInternal) {
            privacyURL = constants_1.default.InternalPrivacyLink;
        }
        else {
            privacyURL = constants_1.default.PrivacyLink;
        }
        var isChinaDomain = false;
        if ((_a = this.props.domainName) === null || _a === void 0 ? void 0 : _a.includes(constants_1.default.CHINA_DOMAIN_NAME)) {
            isChinaDomain = true;
        }
        return (React.createElement(exports.Container, __assign({}, this.props),
            React.createElement("div", null,
                !isChinaDomain && React.createElement(exports.Copyright, __assign({}, this.props),
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " KINCENTRIC"),
                React.createElement(exports.LegalLink, __assign({}, this.props, { target: '_blank', href: constants_1.default.LegalLink }), "Legal Information"),
                React.createElement(exports.PrivacyLink, __assign({}, this.props, { target: '_blank', href: privacyURL }), "Privacy Statement")),
            isChinaDomain && (React.createElement(exports.ChinaFooterContainer, null,
                React.createElement(exports.Copyright, __assign({}, this.props),
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " ",
                    constants_1.default.CHINA_ENTITY_NAME),
                React.createElement(exports.ChinaICPLink, __assign({}, this.props, { target: '_blank', href: constants_1.default.CHINA_ICP_LINK }), constants_1.default.CHINA_ICP_NUMBER))),
            this.props.isLlc && (React.createElement(exports.DebugContent, null,
                React.createElement(exports.ReleaseVersion, __assign({}, this.props),
                    "Release Number: ",
                    this.props.releaseVersion ? this.props.releaseVersion : 'Unknown')))));
    };
    Footer.defaultProps = {
        fontSize: '9px',
        theme: 'light',
    };
    return Footer;
}(React.Component));
exports.Footer = Footer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
